import { useParams } from "react-router-dom";
import { ButtonTypes, LinkButton } from "../../../../../../../../components/ui/Button";
import { UiSizes } from "../../../../../../../../enums";
import I18n from "../../../../../../../localization/I18n";
import PermissionsContext from "../../../../../../../../contexts/permissions/PermissionsContext";
import { PermissionFields } from "../../../../../../../../contexts/permissions/PermissionsTypes";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";

export const EmptyPhaseGridTemplate = (params?: any) => {
  const organisationId = useCurrentOrganisationId();
  const { projectId } = useParams();
  let isOrganisation = !!organisationId;
  let isProject = !!projectId;

  const canEdiProject =
    isOrganisation && isProject
      ? PermissionsContext.canEditField(PermissionFields.PROJECTS, organisationId, Number(projectId))
      : false;
  const canContributeOrg = PermissionsContext.canContributeOrg(organisationId) || canEdiProject;

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <span>{I18n.t("phrases.emptyPhasesGridData")}</span>
      {canContributeOrg
        ? params.showLink && (
            <LinkButton className="m-2" size={UiSizes.SM} href={params.link ?? ""} type={ButtonTypes.LINK_BIG}>
              {I18n.t("phrases.goToPhasesLabel")}
            </LinkButton>
          )
        : I18n.t("phrases.readersNoAccessToCreatePhases")}
    </div>
  );
};
